import React from 'react';
import Resume from '../../components/core-ui/CV/Resume-ui';
import Navbar from '../../components/container/navbar'

const cv = () => {
    return (
        <div>
            <Navbar/>
            <Resume />
        </div>
    );
};

export default cv